const RESERVED = [];

const warn = exposes => {
	/* eslint-disable no-console */
	console.group(
		"Auto-exposing methods. Please replace the generic api.expose() method with the following line:"
	);
	console.warn(exposes);
	console.groupEnd();
	/* eslint-enable no-console */
};

const error = key => {
	/* eslint-disable no-console */
	console.error("Cannot expose API method with reserved name: %s()", key);
	console.info("FIXME: methods will be called via wrapper, anyway…");
	/* eslint-enable no-console */
};

class Callback {
	constructor(context, func, convert) {
		this.context = context;
		this.func = func;
		this.convert = convert;
	}
}

class Observer {
	constructor() {
		this.registry = {};
	}

	attach(api, eventName, convert) {
		return func => {
			if (!this.registry[eventName]) this.registry[eventName] = [];
			let callback = new Callback(api, func, convert);
			this.registry[eventName].push(callback);
		};
	}

	detach(eventName, func = null) {
		const callbacks = this.registry[eventName];
		if (callbacks && callbacks.length) {
			let index = callbacks.findIndex(callback => callback.func === func);
			if (index > -1) callbacks.splice(index, 1);
		}
	}

	notify(eventName, ...args) {
		const callbacks = this.registry[eventName];
		if (callbacks && callbacks.length) {
			callbacks.map(callback => {
				let detachWrapper = () => this.detach(eventName, callback.func);
				let newArgs = [detachWrapper, ...args];
				if (callback.convert) newArgs = callback.convert.apply(null, newArgs);
				callback.func.apply(callback.context, newArgs);
				// parent.postMessage(
				// 	JSON.stringify(
				// 		newArgs
				// 			.filter(x => x.id)
				// 			.map(x =>
				// 				Object.assign({}, x, { element: {}, searchTerm: x.name, target: "tagCloud", type:"wlt.search" })
				// 			)[0]
				// 	),
				// 	"http://localhost:8080/"
				// );
			});
		}
	}
}

class Api {
	constructor(Factory) {

		// window.addEventListener('message', function (e) {
		// 	console.log("component api", e);
		// });

		this._observer = new Observer();
		this._events = {};

		if (Factory.prototype.observer) {
			// eslint-disable-next-line no-console
			console.warn("Redefining observer property of underlying model");
		}

		Factory.prototype.observer = this._observer;
		this._root = new Factory();

		this.api = {
			unwrap: (...args) => {
				if (this._root.unwrap) {
					return this._root.unwrap.apply(this._root, ...args);
				}
				return this._root;
			},

			on: (apiEventName, callback) => {
				if (this._root.on) {
					try {
						this._root.on(apiEventName, callback);
						// eslint-disable-next-line no-console
						console.warn("Directly invoked event handler of underlying model");
						return this.api;
					} catch (error) {
						/* ignore */
					}
				}
				const handler = this._events[apiEventName];
				if (handler) handler(callback);
				return this.api;
			}
		};

		Object.keys(this.api).forEach(key => {
			RESERVED.push(key);
		});
	}

	expose(...apiMethodNames) {
		if (!apiMethodNames.length) {
			this.expose.apply(this, Object.keys(this._root));
			warn(this.exposes());
		} else if (apiMethodNames[0] instanceof Object) {
			apiMethodNames = apiMethodNames.shift();
			Object.keys(apiMethodNames).forEach(key => {
				if (RESERVED.includes(key)) return error(key);
				let methodName = apiMethodNames[key];
				const func = this._root[key];
				this.api[methodName] = (...args) => {
					let result = func.apply(this._root, args);
					return result === this._root ? this.api : result;
				};
				return true;
			});
		} else {
			apiMethodNames.forEach(key => {
				this.expose({ [key]: key });
			});
		}

		return this;
	}

	observe(...apiEventNames) {
		if (!apiEventNames.length) return this;

		let convert = apiEventNames[apiEventNames.length - 1];

		if (apiEventNames.length > 1 && convert instanceof Function) {
			apiEventNames.pop();
		} else {
			convert = null;
		}

		if (apiEventNames[0] instanceof Object) {
			apiEventNames = apiEventNames.shift();
			Object.keys(apiEventNames).forEach(key => {
				let eventName = apiEventNames[key];
				this._events[key] = this._observer.attach(this.api, eventName, convert);
			});
		} else {
			apiEventNames.forEach(key => {
				this.observe({ [key]: key }, convert);
			});
		}

		return this;
	}

	exposes() {
		return (
			"api.expose(" +
			Object.keys(this.api)
				.sort()
				.filter(s => !RESERVED.includes(s))
				.map(s => "'" + s + "'")
				.join(", ") +
			");"
		);
	}

	observes() {
		return (
			"api.observe(" +
			Object.keys(this._observer.registry)
				.sort()
				.map(s => "'" + s + "'")
				.join(", ") +
			");"
		);
	}

	info() {
		return this.exposes() + "\n\n" + this.observes();
	}

	init() {
		return this.api;
	}
}

export { Api, Observer };
